// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  assetId: __t.u64().primaryKey().name("asset_id"),
  gltfRef: __t.string().name("gltf_ref"),
  fidelityVariants: __t.string().name("fidelity_variants"),
  authoringCaps: __t.string().name("authoring_caps"),
  formatVersion: __t.u32().name("format_version"),
  updatedAt: __t.timestamp().name("updated_at"),
});
